var map = {
	"./404.svg": "./resources/js/icons/svg/404.svg",
	"./bill.svg": "./resources/js/icons/svg/bill.svg",
	"./bug.svg": "./resources/js/icons/svg/bug.svg",
	"./chart.svg": "./resources/js/icons/svg/chart.svg",
	"./clipboard.svg": "./resources/js/icons/svg/clipboard.svg",
	"./component.svg": "./resources/js/icons/svg/component.svg",
	"./dashboard.svg": "./resources/js/icons/svg/dashboard.svg",
	"./documentation.svg": "./resources/js/icons/svg/documentation.svg",
	"./drag.svg": "./resources/js/icons/svg/drag.svg",
	"./edit.svg": "./resources/js/icons/svg/edit.svg",
	"./email.svg": "./resources/js/icons/svg/email.svg",
	"./example.svg": "./resources/js/icons/svg/example.svg",
	"./excel.svg": "./resources/js/icons/svg/excel.svg",
	"./eye-open.svg": "./resources/js/icons/svg/eye-open.svg",
	"./eye.svg": "./resources/js/icons/svg/eye.svg",
	"./form.svg": "./resources/js/icons/svg/form.svg",
	"./guide 2.svg": "./resources/js/icons/svg/guide 2.svg",
	"./guide.svg": "./resources/js/icons/svg/guide.svg",
	"./icon.svg": "./resources/js/icons/svg/icon.svg",
	"./international.svg": "./resources/js/icons/svg/international.svg",
	"./language.svg": "./resources/js/icons/svg/language.svg",
	"./link.svg": "./resources/js/icons/svg/link.svg",
	"./list.svg": "./resources/js/icons/svg/list.svg",
	"./lock.svg": "./resources/js/icons/svg/lock.svg",
	"./message.svg": "./resources/js/icons/svg/message.svg",
	"./money.svg": "./resources/js/icons/svg/money.svg",
	"./nested.svg": "./resources/js/icons/svg/nested.svg",
	"./password.svg": "./resources/js/icons/svg/password.svg",
	"./pdf.svg": "./resources/js/icons/svg/pdf.svg",
	"./people.svg": "./resources/js/icons/svg/people.svg",
	"./peoples.svg": "./resources/js/icons/svg/peoples.svg",
	"./qq.svg": "./resources/js/icons/svg/qq.svg",
	"./shopping.svg": "./resources/js/icons/svg/shopping.svg",
	"./size.svg": "./resources/js/icons/svg/size.svg",
	"./star.svg": "./resources/js/icons/svg/star.svg",
	"./tab.svg": "./resources/js/icons/svg/tab.svg",
	"./table.svg": "./resources/js/icons/svg/table.svg",
	"./theme.svg": "./resources/js/icons/svg/theme.svg",
	"./tree.svg": "./resources/js/icons/svg/tree.svg",
	"./user.svg": "./resources/js/icons/svg/user.svg",
	"./wechat.svg": "./resources/js/icons/svg/wechat.svg",
	"./yandex-brands.svg": "./resources/js/icons/svg/yandex-brands.svg",
	"./zip.svg": "./resources/js/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/icons/svg sync \\.svg$";